import { api } from "../../../api";

const root = process.env.REACT_APP_BACKEND_FINANCE_URL;
const route = api(root);
const token = JSON.parse(localStorage.getItem("user"))?.userToken;

const BudgetImportServices = {
  async importBudget(file) {
    try {
      let { data } = await route.post(
        `/BudgetImport/ImportYearlyBudgetCommand`,
        file,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );

      return data;
    } catch (err) {
      console.log("error", err);
    }
  },
  async createLineItem(payload) {
    try {
      let { data } = await route.post(
        `/BudgetImport/CreateBudgetItemCommand`,
        { ...payload },
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );

      return data;
    } catch (e) {
      console.log("error", e);
    }
  },
  async getBudgetItems({ search, startDate, endDate, pageSize, pageNumber }) {
    try {
      let { data } = await route.get(
        `/BudgetImport/GetBudgetDetailsQuery?PageSize=${pageSize}&PageNumber=${pageNumber}&Search=${search}`,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );

      return data;
    } catch (e) {
      console.log("error", e);
    }
  },
  async getBudgetSummary() {
    try {
      let { data } = await route.get(`/BudgetImport/BugedetIncomeTotalAmount`, {
        headers: {
          Authorization: "Bearer " + token,
        },
      });

      return data;
    } catch (e) {
      console.log("error", e);
    }
  },
};

export default BudgetImportServices;
